
import { AssetEntityDecorator } from '../../asset/model/asset.decorator';
import { Asset } from '../../asset/model/asset.model';
import { ASSET_MAINTENANCE_METADATA } from './asset-maintenance.metadata';
import { AssetMaintenance } from './asset-maintenance.model';
import { EntityDecorator, GenericEntityDecorator } from '@scisys-uim/uim-common';


export abstract class AssetMaintenanceEntityDecoratorBase extends GenericEntityDecorator<AssetMaintenance, number> {
  constructor() {
    super(ASSET_MAINTENANCE_METADATA, {
      get asset(): EntityDecorator<Asset, number> {
        return new AssetEntityDecorator();
      }
    }, {
    });
  }
  toKeyObjectFromRouteParams(params: any): number {
    if (params == null || params.assetMaintenanceId == null) {
      return null;
    }
    return parseInt(params.assetMaintenanceId);
  }
  toKeyUrlPathSegments(key: number): string {
    if (key == null) {
      return null;
    }
    return '' + key;
  }
  toKeyRouteSegments(item: AssetMaintenance): any[] {
    const key: number = this.metadata?.toKeyObject(item);
    if (key == null) {
      return null;
    }
    return [key];
  }
}




